import { render } from "./HeaderInfo.vue?vue&type=template&id=6c500d0a"
import script from "./HeaderInfo.vue?vue&type=script&lang=js"
export * from "./HeaderInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__